import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { TemplateUtenteForm } from '../../../form/profili-utente/template-utente-form';
import { UtenteProfiloRequest } from '../../../models/dto/utente-profilo-request';
import { TemplateUtenteProfilo } from '../../../models/profili-utente/template-utente-profilo';
import { UtenteProfilo } from '../../../models/profili-utente/utente-profilo';

declare var closeModal: any;

@Component({
    selector: 'div [template-utente-update-form]',
  templateUrl: '../../../form/profili-utente/template-utente-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class TemplateUtenteUpdateComponent extends TemplateUtenteForm implements OnInit {
  templateUtente: TemplateUtenteProfilo;
  urlUpdate: string;
  @Input() display: boolean;
  @Output()
  onReturn: EventEmitter<TemplateUtenteProfilo> = new EventEmitter<TemplateUtenteProfilo>();


  constructor( @Inject(OperationsService) operationService: OperationsService, @Inject(FormBuilder) campiForm: FormBuilder, @Inject(HelpersService) helpers: HelpersService) {
    super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Modifica profilo utente');
    this.addMod = false;
    this.isInserimento(false);
  }

  getRequest(request: TemplateUtenteProfilo) {
//    this.operationService.updateBeneImmobile(this.urlUpdate,this.sezione.id, request).subscribe(response => this.sezioneBeneImmobileUpdated(response));
     this.operationService.updateTemplateUtente(this.urlUpdate, request).subscribe(response => this.datiTemplateUtente(response));
  }

  getRequestAddUtente(request: TemplateUtenteProfilo) {
      this.operationService.updateUtenteProfilo(this.urlUpdate, new UtenteProfiloRequest(this.utente, request)).subscribe(response => this.datiUtenteProfilo(response));
  }

  getTemplateUtente() {
    return this.templateUtente;
  }

  datiUtenteProfilo(response) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(this.templateUtente);
    }
  }

  datiTemplateUtente(response) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response);
    }
  }

  inizializza(urlUpdate: string, urlGetTemplates: string, urlGetTemplate: string, utente: UtenteProfilo, templateUtente: TemplateUtenteProfilo) {
    this.templateUtente = templateUtente;
    this.utente = utente;
    this.urlUpdate = urlUpdate;
    this.urlGetTemplate = urlGetTemplate;
    this.urlGetTemplates = urlGetTemplates;
    this.populateSelect();
    this.createForm();
  }
}
